// extracted by mini-css-extract-plugin
module.exports = {"accordion__child-wrapper":"dynamo-accordion_accordion__child-wrapper__G1jk_"};